"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DASH = exports.SITE_NAME = void 0;
exports.SITE_NAME = '| Lokalportal';
exports.DASH = '–'; // This is an "en dash" not a minus sign
exports.default = {
    addToCalender: {
        appleCalender: 'Apple Calender',
        google: 'Google',
        outlook: 'Outlook',
        text: 'Додати до календаря',
    },
    appState: {
        appStartNoConnectionToServerNote: 'Здається, виникла проблема з інтернет-зєднанням.',
        restartAction: 'Додаток перезавантажується',
        restartReason: 'Упс...у програму потрапила помилка.Тому потрібно перезапустити додаток ' +
            'Ми виправимо помилку якнайшвидше.',
        updateActionUpdateLater: 'Пізніше',
        updateActionUpdateNow: 'Оновити зараз',
        updateAvailableBody: 'Оновість зараз програму, щоб ознайомитись з останніми функціями.',
        updatePermanentlyUnavailableBody: 'На жаль, нова версія недоступна для вашого телефону.',
        updatePermanentlyUnavailableTitle: 'Версія не підтримується',
        updateRequiredBody: 'Оновіть додаток, щоб почати знову.',
        updateRequiredTitle: 'Версія не підтримується',
        updateTemporarilyUnavailableBody: 'В даний час ми працюємо над нашими серверами. Будь ласка, зайдіть пізніше.',
        updateTemporarilyUnavailableTitle: 'Тимчасово недоступний',
    },
    authentication: {
        agb1: 'Наші ',
        agb2: 'Захист даних',
        agb3: ' Можете ви ',
        agb4: 'тут',
        agb5: ' прийняти.',
        ageConfirmation1: 'Я згоден ',
        ageConfirmation2: 'Умови використання',
        ageConfirmation3: ' і підтверджую, що я повнолітній',
        ageConfirmationError: 'Будь ласка, прийміть наші умови використання.',
        alreadyRegistered: 'У мене вже є профіль',
        confirmPasswordReset: 'Скинути пароль',
        errorAddress: 'Будь ласка, перевірте свою електрону адресу.',
        errorAutomaticLoginModalBody: 'Приємно, що ви знову з нами. 🤗 Зареєструйтесь будь ласка знову. ',
        errorLogin: 'Ваші дані доступу введено неправильно.',
        errorLoginModalBody: 'Будь ласка, перевірте свою адресу електронної пошти та пароль.',
        errorLoginModalTitle: 'Помилка логіну',
        errorMissingEmail: 'Будь ласка, введіть свою електронну адресу.',
        errorMissingPassword: 'Будь ласка, введіть свій пароль.',
        errorOAuthLoginUserDeniedAuthorization: 'Доступ заборонено.',
        errorOAuthLoginUserNotRegistered: 'Будь ласка, спочатку зареєструйтеся, щоб ви могли увійти.',
        errorPassword: 'Будь ласка, перевірте свій пароль.',
        errorPasswordReset: 'На жаль, ми не змогли надіслати вам електронного листа. ' +
            'Будь-ласка спробуйте пізніше.',
        errorRepeatPassword: 'Введені паролі не співпадають.',
        facebookRegistrationEmailSubTitle: 'Будь ласка, введіть Вашу адресу електронної пошти:',
        facebookRegistrationEmailTitle: 'Адреса електронної пошти відсутня',
        internetConnectionProblemBody: 'Перевірте підключення до Інтернету та повторіть спробу.',
        internetConnectionProblemTitle: 'Проблем з інтернет з єднанням',
        loginTitle: 'Приємно, що ви знову з нами.!',
        loginWithApple: 'Вхід через Apple',
        loginWithFacebook: 'Вхід через Facebook ',
        newPassword: 'Новий пароль',
        newPasswordRepeat: 'Повторити новий пароль',
        passwordChanged: 'Ваш пароль успішно змінено.',
        passwordChangedLongText: 'Тепер ви можете увійти в систему, використовуючи свою адресу електронної пошти та новий пароль.',
        passwordForgot: 'Забули пароль?',
        passwordForgotBody: 'Це може статися з кожним... Просто введіть свою адресу електронної пошти нижче ' +
            'потім ми надішлемо вам електронний лист для зміни пароля.',
        passwordResetTitle: 'Скинути пароль?',
        registerLopo: 'Зареєструйтеся зараз на місцевому порталі',
        registerNow: 'Зараз ви можете зареєструватися безкоштовно',
        registerWithApple: 'Реєстрація з Apple',
        registerWithFacebook: 'Реєстрація з Facebook',
        repeatPassword: 'Повторити пароль',
        resetConfirmationBody: 'Ми надіслали вам електронного листа. Будь ласка, перейдіть за посиланням у листі, ' +
            'щоб змінити пароль.',
        resetConfirmationTitle: 'У вас є пошта!',
        sendEmail: 'Надіслати електроний лист',
        wantRegister: 'Я хочу зареєструватися',
    },
    blacklist: {
        blacklist: 'Заблокувати',
        forEver: 'Назавжди',
        modalContent: 'Якщо ви заблокуєте сусіда, ви більше не зможете побачити його допис в стрічці новин ' +
            'перглядати та надсилати приватні повідомлення. У розділі Заблоковані ' +
            'сусіди ви можете скасувати налаштування у будь-який час.',
        modalTitle: 'Підтвердьте блокування',
        modalTitleRemove: 'Заблокований сусід',
        profile: 'Заблокований користувач',
        revertBlacklist: 'Разблокувати користувачів',
        wizardExplanation: 'Тут ви можете побачити заблокованих користувачів. ' +
            'Ви можете скасувати  налаштування, натиснувши на коло.',
        wizardHeaderText: 'Заблоковані сусіди',
    },
    comments: {
        attachImage: 'Додати зображення',
        comment: 'Коментувати',
        commentCount: (count) => `${count} ${count === 1 ? 'Коментар' : 'Коментарі'}`,
        disabled: 'Kommentare wurden deaktiviert',
        discardChanges: 'Скасувати зміни',
        edit: 'Редагувати коментар',
        editCancel: 'Скасувати редагування коментаря',
        editCancelAlert: 'Ви впевнені, що хочете відхилити зміни?',
        editCancelCTA: 'відхилити',
        editCancelText: 'Редагування коментаря',
        editError: 'Не вдалося змінити ваш коментар. Будь ласка спробуйте ще раз.',
        edited: (date) => `(Bearbeitet – ${date})`,
        nonYetMessage: 'Скажіть, що ви думаєте про цей пост.',
        noneYet_APP: 'Тут ще немає коментарів.',
        noneYet_WEB: 'Ще немає коментарів',
        placeHolder_APP: 'Ваш коментар',
        placeHolder_WEB: 'Залиште коментар',
        remove: 'Видалити коментар',
        removeError: 'Не вдалося видалити ваш коментар. Будь ласка спробуйте ще раз.',
        removedByAdmin_APP: 'Цей коментар був видален адміністратором.',
        removedByAdmin_WEB: 'Цей коментар видалив модератор.',
        removedByAuthor: 'Автор видалив цей коментар.',
        removedByCommentableAuthor_APP: 'Цей коментар видалив автор допису.',
        removedByCommentableAuthor_WEB: 'Цей коментар видалив автор публікації.',
        removedByUnknown: 'Цей коментар видалено.',
        submit: 'Надіслати коментар',
        submitError: 'Не вдалося надіслати ваш коментар. Будь ласка спробуйте ще раз.',
        sureToRemove: 'Ви впевнені, що хочете видалити цей коментар??',
        total: 'Загалом',
        update: 'Оновити коментар',
        write: 'Залишити коментар',
    },
    cookieConsent: {
        linkText: 'Використання файлів cookie.',
        message: 'Щоб запропонувати вам кращий інтерфейс користувача, ми використовуємо файли cookie. ' +
            'Використовуючи локальний портал, ви погоджуєтесь з правилами ',
    },
    createFlag: {
        messagePlaceholder: 'Розкажіть про ващі роздуми.',
        reason: 'Причина',
        submitTitle: 'На ваш допис поскаржилися',
        successText: 'Ви успішно поскаржились на допис. Ми розглянемо скаргу якомога швидше. Дуже дякую!',
        text: 'Вас турбує зміст цього допису?' +
            ' Тоді ви можете поскаржитися на публікацію тут, і ми розглянемо її якнайшвидше..' +
            ' Автор допису не буде проінформований про скаргу.',
        title: 'Поскаржити на публікацію',
    },
    dateFormat: {
        around: (prefix, date) => `${prefix}, ${date}`,
        at: 'um',
        between: (from, to) => `${from} - ${to}`,
        clock: 'Година',
        eventFeed: 'dd. ДД.ММ.РРРР',
        eventFeedHeaderLong: 'ddd, ДД.ММ.РРРР',
        eventFeedHeaderRangeLong: 'ДД.ММ.РРРР',
        eventFeedHeaderRangeShort: 'ДД.ММ.',
        eventFeedHeaderShort: 'ДД.ММММ.РРРР',
        from: 'від',
        // will be used for relative times like "In 10 Minuten"
        future: (relTime) => `О ${relTime}`,
        // will be used if the relative time is less than 45 seconds in the past
        // (see https://momentjs.com/docs/#/customization/relative-time-threshold/)
        justNow: 'Щойно',
        last: 'Останній',
        onTheWeekend: 'На вихідних',
        ongoing: 'Відбувається прямо зараз',
        // will be used for relative times like "Vor 10 Minuten"; special handling for the
        // "just now" case, see definition of property 's' below
        past: (relTime) => relTime === 'Прямо зараз' ? 'Щойно' : `Vor ${relTime}`,
        short: 'ДД.ММ.РРРР',
        timeOnly: 'H:mm [Uhr]',
        tiny: 'ДД.ММ.РР',
        to: 'до',
        today: 'Сьогодні',
        tomorrow: 'Завтра',
        withDayOfWeekLong: 'dddd, ДД.ММ.РРРР',
        withDayOfWeekShort: 'dddd, ДД.ММ.РРРР',
        yesterday: 'Вчора',
    },
    datePicker: {
        buttonOK: 'Отримати',
        buttonReset: 'Відновлення значень за замовчуванням',
        selectEndDate: 'Виберіть період та ',
        shortFriday: 'ПТ',
        shortMonday: 'ПН',
        shortSaturday: 'СБ',
        shortSunday: 'НД',
        shortThursday: 'ЧТ',
        shortTuesday: 'ВТ',
        shortWednesday: 'СР',
    },
    emojiMart: {
        activity: 'Активність',
        custom: 'Локальний порт',
        flags: 'Помітки',
        foods: 'Їжа & Напої',
        nature: 'Тварини & Природа',
        notfound: 'Немає результатів',
        objects: 'Речі',
        people: 'Емоджі & Люди',
        places: 'Подорожі & Місця',
        recent: 'Останнє',
        search: 'Пошук',
        symbols: 'Символи',
    },
    eventParticipants: {
        deleteModalBody: 'Ви дійсно хочете припинити відвідувати подію?',
        deleteModalButton: 'Більше не брати участі',
        deleteModalTitle: 'Більше не приймаєте участі?',
        iWantToParticipate: 'Я хочу взяти участь',
        imParticipating: 'Я беру участь',
        justYou: 'Ти приймаєш участь',
        participants: 'Учасник',
        showParticipantsList: 'Показати список учасників',
        you: 'Ти',
    },
    eventfeed: {
        feedLoadingError: 'Не вдалося завантажити події',
        freeDateChoice: 'Вільний вибір',
        itemLoadingError: 'Не вдалося завантажити цю подію',
        myEvents: 'Мої події',
        noEventsAvailable: 'На жаль, немає подій за цей період.',
        relatedContentSubtitle: 'Ця подія відбудеться в найближчі кілька днів.',
    },
    feedback: {
        acceptAndSubmit: 'Погодитися і відправити',
        emailPlaceholder: 'Ваш адрес електронної пошти',
        errorInputRequired: 'Будь ласка, надайте свій відгук.',
        errorSending: 'Упс... Ваш відгук не було відправлено.',
        message: 'Ви помітили помилку, чи маєте ви ідеї або питання щодо цього? ' +
            'Якщо так, то звяжіться з нами',
        messagePlaceholder: 'Ваш відгук',
        onboardingErrorFeedbackPlaceholder: 'Ми завжди можемо покращити роботу локального порталу, ' +
            'тому ми чекаємо на ващі повідомлення.',
        onboardingErrorFeedbackTitle: 'Вибачте, щось пішло не так.' +
            '\nБудь ласка, надішліть нам свій відгук, щоб ми могли вирішити проблему якнайшвидше.',
        terms: 'Я згоден зі зберіганням своїх даних для обробки та  відповіді на запити' +
            'додаткові питання. Я можу заперечити це у будь-який час. Для цього достатньо електронного листа: ' +
            'kontakt@lokalportal.de',
        thanksMessage: 'Дякую за ваш відгук! Ми зв’яжемося з вами якнайшвидше. ' +
            'Ви також можете відвідати наш блог, де ви знайдете відповіді на',
        thanksMessageLink: 'найпоширеніші запитання',
        thanksTitle: 'Дуже дякуємо!',
        title: 'Допоможіть нам своїм відгуком',
    },
    follow: {
        follow: 'Стежити',
        followAlertMessage: (profileName) => `Ви слідкуєте за „${profileName}” .`,
        following: 'Підписатися',
        noFollowersMessage: 'Ви можете змінити це дуже швидко!! Представтеся в оточенні, ' +
            'тримайте своїх сусідів в курсі новин, а також поділіться з іншими свіїм профілем. ' +
            'Потім тут поснеться своя вечірка.',
        noFollowersTitle: 'На горизонті не має читачів? 👀 🔍',
        showFollowers: 'Показати читачів',
        turnOffNotifications: 'Вимкнути сповіщення',
        turnOnNotifications: 'Ввімкнути сповіщення',
        unfollow: 'Більше не стежити',
        unfollowAlertBody: (profileName) => `Коли ви більше не слідкуєте за ${profileName}, ` +
            'ви більше не отримуєте сповіщення о нивинах цього користувача та' +
            'він не буде більше відображатись на початку сторінки.',
        unfollowAlertTitle: 'Більше не стежити?',
    },
    graylist: {
        graylist: 'Без звуку🤐',
        modalTitle: 'Прихований профіль 🤐',
        mute: 'Вимкнути звук',
        remainingDays: (days) => `Ще ${days === 1 ? '1 день' : `${days} днів`}`,
        revertGraylist: 'Не приховувати більше профіль',
        successMessage: (profileName, durationInDays) => `Дописи „${profileName}“ не будуть відображатися${durationInDays === 1 ? '1 день' : `${durationInDays} дні`} ` +
            '. Це ви можете змінити в налаштуваннях.',
        wizardExplanation: 'Тут ви можете переглянути всі профілі, які ви приховали. ' +
            'Ви можете скасувати налаштування, натиснувши на маленький динамік.',
        yet: 'Та',
    },
    groups: {
        confirmMember: 'Додати учасника групи',
        confirmMemberFail: (name) => `Під час додавання учасника групи "${name}" сталася помилка..`,
        confirmMemberSuccess: (name) => `Ви додали учасника групи "${name}"..`,
        confirmations: {
            accept: {
                body: 'Bist du dir sicher, dass du diesen Benutzer akzeptieren möchtest?',
                buttonConfirm: 'Bestätigen',
                title: 'Akzeptieren bestätigen',
            },
            reject: {
                body: 'Bist du dir sicher, dass du diesen Benutzer ablehnen möchtest?',
                buttonConfirm: 'Bestätigen',
                title: 'Ablehnen bestätigen',
            },
            remove: {
                body: 'Bist du dir sicher, dass du dieses Mitglied entfernen möchtest?',
                buttonConfirm: 'Bestätigen',
                title: 'Entfernen bestätigen',
            },
        },
        confirmedUsers: 'Gruppenmitglieder',
        ctaBlocked: {
            buttonLabel: 'До стрічки новин',
            info: 'Лише сусіди та редактори мають доступ до груп. ' +
                'Просто перейдіть до свого приватного профілю.',
            title: 'Тільки для сусідів',
        },
        ctaNotJoinedFeed: {
            infoCanJoin: 'Приєднуйтесь до цієї групи, якщо хочете поділитися цим з іншими сусідами.',
            infoCanNotJoin: 'На жаль, ви не можете приєднатися до цієї групи, оскільки вона знаходиться за межами вашого регіону.',
            infoLoggedOut: 'Зареєструйтеся зараз та приєднайтеся до цієї групи,' +
                'якщо ви хочете обмінятися ідеями з іншими сусідами.',
            title: 'Звучить цікаво?',
        },
        ctaNotJoinedMembers: {
            infoCanJoin_APP: (groupName) => `Як тільки ви приєдналися до групи ${groupName}, ви можете перглянути інших учасників ` +
                'та почати з ними спілкування.',
            infoCanJoin_WEB: 'Як тільки ви приєдналися до групи, ви можете перглянути інших учасників ' +
                'та почати з ними спілкування.',
            infoCanNotJoin: 'Ви не можете побачити учасників цієї групи, ' +
                'оскільки ви живете в іншому регіоні.',
            title_APP: 'Ви ще не є учасником данної групи.',
            title_WEB: (groupName) => `Чи хочете ви приєднатися до данної групи „${groupName}” ?`,
        },
        ctaRecommendation: {
            body: 'Ви великий шанувальник собак і хотіли б поговорити зі своїми сусідами ' +
                'про своїх чотирилапих друзів? Або ви цікавитесь фотографією і хотіли б ' +
                'створити фотоспільноту разом з іншими? Запропонуйте ідеї своїхй групі! Заповніть ' +
                'інформацію та надсилайте свої пропозиції. Потім ми звяжемося з вами якнайшвидше.',
            groupDescriptionInput: 'Опишіть свою групу',
            groupNameInput: 'Дайте імя своїй групі',
            header: 'Запропонувати групу',
            title: 'Ще не вибрали улюблену тему?',
        },
        eliminateMember: 'Видалити учасника групи',
        eliminateMemberFail: (name) => `Під час видалення учасника групи "${name}" сталася помилка.`,
        eliminateMemberSuccess: (name) => `Ви видалили учаника групи "${name}".`,
        groupNotFoundError: 'Групу не знайдено.',
        groups: 'Групи',
        groupsInMyRegion: 'Групи в моєму регіоні',
        inviteNeighborSubtitle: 'Додати сусідів та друзів',
        inviteNeighborTitle: 'запросити сусідів',
        joinClosedGroupError: (groupName) => `Під час пошуку групи ${groupName} сталася помилка.`,
        joinClosedGroupModal: {
            confirm: 'Запити',
            message: 'Ви надсилаєте запит на приєднання до цієї приватної групи, яка керується ' +
                'адміністратором. Після підтвердження вашого запиту, ви можете переглядати та створювати повідомлення.',
            title_APP: (groupName) => `Бажаєте приєднатися до ${groupName}?`,
            title_WEB: (groupName) => `Бажаєте приєднатися до ${groupName}?`,
        },
        joinClosedGroupSuccess: (groupName) => `Ваш запит до групи "${groupName}" надіслано.`,
        joinGroup: 'Приєднатися',
        joinGroupError: (groupName) => `Під час приєднання до групи ${groupName} сталася помилка.`,
        joinGroupSuccess: (groupName) => `Ви стали учасником групи „${groupName}“.`,
        leaveGroup: 'Покинути групу',
        leaveGroupError: (groupName) => `Під час видалення з групи ${groupName}сталася помилка.`,
        leaveGroupModal: {
            confirm: 'Покинути',
            message: 'Якщо ви покинете групу, ви більше не зможете бачити повідомлення в цій групі. ' +
                'Ви також більше не отримуватимете сповіщень про те, що відбувається в групі.',
            title_APP: (groupName) => `покинути „${groupName}“?`,
            title_WEB: (groupName) => `Ви справді хочете покинути групу „${groupName}“?`,
        },
        leaveGroupSuccess: (groupName) => `Ви успішно покинули групу "${groupName}".`,
        loadGroupError: 'не можливо завантажити групу.',
        memberCount: (count) => `${count} ${count === 1 ? 'Учасник' : 'Учасники'}`,
        memberCountHeader: (count) => `${count} Учасники групи`,
        memberListAdminSection: 'Адміністратори',
        memberListMemberSection: 'Учасники групи',
        moreGroups: 'Інші групи',
        moreGroupsEmpty: 'Нажаль, тут немає груп.',
        myGroups: 'Твої групи',
        notifications: {
            changeError: `Ein Fehler ist aufgetreten. Bitte später erneut versuchen.`,
            changeSuccess: (groupName, enabled) => `Die Benachrichtigungen für die Gruppe ${groupName} sind ${enabled ? 'eingeschaltet' : 'ausgeschaltet'}.`,
            label: 'Benachrichtigungen',
        },
        pending: 'Перш ніж ви зможете переглядати та створювати повідомлення, ваш запит має прийняти адміністратор ',
        pendingGroups: 'Anstehende Gruppen',
        pendingUsers: 'Anstehende Benutzer',
        recommendationSubtitle: 'Запропонуйте нову групу',
        recommendationSuccessBody: 'Ми зробимо все можливе, щоб відповісти вам якомога швидше.',
        recommendationSuccessTitle: 'Ваша пропозиція на шляху до нас',
        recommendationTitle: 'Не має вашої улюбленої теми',
        sendRecommendationBody: (title, description) => `Запит: Нова група \nНазва: ${title} \nОпис: ${description}`,
        shareGroup: 'Поділитися групою',
        shareGroupMessage: 'Просто подивіться! Я знайшов цю групу на місцевому порталі, ' +
            'яка також може бути вам цікавий.',
        showMemberList: 'Показати учасників групи',
    },
    header: {
        events: 'Події',
        groups: 'Групи',
        mainPage: 'Стартова сторінка',
        notifications: 'Сповіщення',
        profilesDirectory: 'Пошук',
    },
    imageAlt: {
        addImage: 'Додати зображення',
        addedMedia: 'Додані медіа',
        avatar: 'Аватар',
        campaignLoading: 'Кавантаження кампанії',
        campaignSuccess: 'Успіх кампанії',
        contactPerson: 'Контактна особа',
        headerImage: 'Заголовок зображення',
        imageCropper: 'Обрізати зображення',
        linkPreview: 'Попередній перегляд посилання',
        loadingSpinner: 'Процес завантаження',
        markerImage: 'Маркер на карті',
        poweredByGoogle: 'На основі Google',
        snapshotPreview: 'Попередній перегляд знімків',
        staticMap: 'Карта',
        success: 'Успіх',
    },
    intermediateProfile: {
        completeProfile: {
            body: 'Заповніть свій профіль зараз, щоб ви могли використовувати всі функції локального оточення.',
            bodyTitle: 'Майже зроблено...',
            title: 'Започнити профіль',
        },
        confirmEmail: {
            body1: 'Будь ласка, підтвердіть Вашу електронну адресу',
            body2: '. Також перевірте папку зі спамом, якщо ви не можете знайти лист. ' +
                'Якщо у вас виникли проблеми, надішліть нам повідомлення ',
            bodyTitle: 'Перевірте свою поштову скриньку...',
            buttonText: 'Повторне підтвердження електронною поштою',
            title: 'Підтвердити адресу електронної пошти',
        },
        register: {
            body: 'Зареєструйтеся зараз, і ви вже зможете читати дописи своїх сусідів ' +
                'та спілкуватися з ними.',
            bodyTitle: 'Ввійти',
            loginButton: 'Підписатися',
            registerButton: 'Зареєструватися',
            title: 'Сусідство',
        },
        verify: {
            body: 'Ви можете обмінюватися інформацією зі своїми сусідами в будь-якому місці своєї місцевості лише після того, як ви пройдете верифікацію',
            bodyTitle: 'Приєднуйтеся зараз!',
            button: 'Підтвердіть зараз',
            title: 'Верифікуйте профіль',
        },
    },
    item: {
        deletePost: 'Видалити допис',
        deletePostConfirmationQuestion: 'Чи справді ви хочете видалити допис?',
        duplicatePost: 'Копіювати допис',
        editPost: 'Рудагувати допис',
        keepAddress: 'Отримати адресу',
        notFound: 'Упс... На жаль, допис більше не існує.',
        notFoundTitle: 'Допис не знайдено',
        snapshotUpdatingError: 'Не вдалося відредагувати знімок.',
        updatingError: 'Не вдалося оновити публікацію.',
    },
    landingPage: {
        info: 'У місцевому оточенню можна відразу дізнатися, що відбувається у вашому районі.',
        learnMore: 'Дізнатися більше',
        notFound: 'На жаль, сторінку не знайдено :(',
        return: 'Повернутися до місцевого оточення',
        title: 'Що нового відбувається у сусідстві?',
    },
    locationChanger: {
        addressNotFound: 'Будь ласка, введіть повну адресу з вулицею та містом!',
        areaNotReleased: 'Адреса, яку ви ввели, не активна. Будь ласка, введіть іншу локацію!',
        areaNotReleasedAlertBody: 'На жаль, локальний портал поки що недоступний у цьому регіоні.',
        areaNotReleasedAlertTitle: 'Ми ще не там',
        areaNotReleasedShort: 'На жаль, ця локація ще не активована.',
        brokenAddress: 'Недійсна адреса',
        currentLocation: 'Поточне місцезнаходження',
        defaultError: 'Введене місцеположення недійсне. Будь ласка, введіть іншу адресу!',
        enableGeolocationInfo: 'Спочатку надайте нам доступ до вашого місцезнаходження. ' +
            'Для цього просто перейдіть у свої налаштування.',
        fetchLocationError: 'Не вдалося визначити ваше місцезнаходження.',
        headerLocationChanger: 'Вибрати місце',
        homeLocation: 'Моя адреса',
        inputPlaceholder: 'адреса або місце розташування',
        invalidParameters: 'Будь ласка, спробуйте ще раз або введіть інше місце розташування!',
        outOfReach: 'Введене місце виходить за межі дозволеного діапазону. Будь ласка, введіть інше місце!',
        outOfReachBody: 'Адреса знаходиться за межами дозволеного діапазону.',
        outOfReachTitle: 'Будь ласка, введіть інше місце!',
        popularPlaces: 'Популярні місця',
        removeAddress: 'Видалити адресу',
        searchResults: 'Результати пошуку',
        updatingFeedLocation: 'Ваше мімце знаходження було оновлено.',
    },
    mailbox: {
        goBackButtonTitle: 'Назад до поштової скриньки',
        homepage: 'Стартова сторінка',
        loadMoreMessages: 'Завантажити попередні повідолення',
        mailBox: 'Абонентна поштова скринька',
        moreMessages: 'Подальші повідомлення',
        noConversationSelected: 'Не вибрано жодної бесіди',
        replyPlaceholder: 'Напишіть відповідь',
        sendMessageWithNeighbors: 'Спілкуйтеся зі своїми сусідами',
    },
    mainMenu: {
        appAnnouncement: 'Що нового в додатку',
        conversations: 'Абонентна поштова скринька',
        conversationsNotAvailableBody: 'На жаль, зараз ви не можете читати приватні повідомлення в додатку.',
        conversationsNotAvailableTitle: 'Поштова скринька недоступна',
        createBlog: 'Додати профіль',
        setTheme: 'Вибрати тему',
        setThemeButton: 'Тема',
        spread: 'запросити сусідів',
        themeDark: 'Нічь',
        themeLight: 'День',
        themeSystem: 'Системні налаштування',
        toProfile: 'Мій профіль',
    },
    manageBlogProfileAdmin: {
        formBodyEnd: ' може допомогти, ' +
            'він сам повинен бути зареєстрований як сусід в локальному порталі.\n\n' +
            'Коли ви надіслали запит, це може зайняти деякий час, ' +
            'поки адміністратора не буде додано до вашого профілю. ' +
            'Але ми подбаємо про це якнайшвидше. 👩‍🔧👷‍♂️',
        formBodyStart: 'Перш ніж хтось спробує допомогти вам у керуванні вашим профілем ',
        formSuccessBodyEnd: ' додано як адміністратор. ' +
            'Якщо у вас виникли запитання, просто надішліть нам повідомлення: ',
        formSuccessBodyStart: 'Ваш запит надіслано до служби підтримки місцевого порталу. ' +
            'Ми зв’яжемося з вами по електронній пошті, як тільки зможемо ',
        formSuccessTitle: 'Ура... скоро ви зможете працювати разом!',
        menuDescription: 'Керуйте профілем з кількома користувачами',
        menuName: 'Додати адміністратора',
    },
    map: {
        expandButtonTooltip: 'Повноекранний режим',
        failedGetLocationError: 'Ой, а де ви зараз знаходетесь? Ми знайшли вашу адресу.',
        homeButtonTooltip: 'До рідного міста',
        locateMeButtonTooltip: 'До актуального місця знаходження',
        locationChangerButtonTooltip: 'Змінити місце знаходження',
        searchThisArea: 'Відкрийте нове для себе в цій області',
        zoomInButtonTooltip: 'Збільшити',
        zoomOutButtonTooltip: 'Зменшити',
    },
    metatags: {
        defaultTag: {
            author: 'Місцевий портал',
            copyright: 'Місцевий портал, Гамбург, Германія',
            description: 'Місцевий портал – це платформа для місцевого життя. Обміняйтеся ідеями з сусідами' +
                'та відразу дізнайтеся, що відбувається у вашому оточенні.',
            email: 'redaktion@lokalportal.de',
            siteName: 'Місцевий портал',
            title: 'Місцевий портал – це платформа для місцевого життя',
        },
        descriptions: {
            eventsfeed: (locationName) => `Усі події в ${locationName} та околицях. ` +
                'З нашими порадами щодо музики, мистецтва та культури ви завжди будете в курсі.',
            groupOverview: 'Ви шукаєте однодумців, щоб поділитися своїм улюбленим хобі ' +
                'чи інтересами? У наших групах ви можете обмінюватися думками з сусідами на певні теми.',
            newsfeedAdditionalPage: (startIndex, endIndex, locationName) => `Дописи ${startIndex} до ${endIndex} ${exports.DASH} ` +
                `Всі новини та інформація з ${locationName} та ` +
                'околицях – безпосередньо від редакції, від обєднань, організацій та ваших сусідів.',
            newsfeedFirstPage: (locationName) => `Всі новини та інформація з ${locationName} та ` +
                'околицях – безпосередньо від редакції, від обєднань, організацій та ваших сусідів.',
            profilesDirectory: (locationName) => `Відкрийте для себе обєдання, організації, підприємства та органи державної влади в ${locationName} та околицях.`,
            profilesDirectoryCategoryAuthorityProfiles: (locationName) => `Відкрийте для себе обєдання, організації, підприємства та органи державної влади в  ${locationName}та околицях.`,
            profilesDirectoryCategoryPressProfiles: (locationName) => `Відкрийте для себе редакції в ${locationName}та околицях.`,
            profilesDirectoryCategoryPrivateProfiles: (locationName) => `Відкрийте для себе сусідів в ${locationName} та околицях.`,
            shapeSponsors: 'Приєднуйтеся до міця та ваш профіль' +
                'стане ще більш помітним – прямо на стартовій сторінці.',
        },
        titles: {
            categorizedEventsfeed: (locationName, category) => `Події ${exports.DASH} ` +
                `${category} ${exports.DASH} ${locationName} ${exports.SITE_NAME}`,
            createProfile: `Додати профіль ${exports.SITE_NAME}`,
            detailsPage: (title) => `${title} ${exports.SITE_NAME}`,
            eventParticipating: `Мої Події${exports.SITE_NAME}`,
            eventParticipations: `Список учасників ${exports.SITE_NAME}`,
            eventsfeed: (locationName) => `Події ${exports.DASH} Огляд ${exports.DASH} ${locationName} ${exports.SITE_NAME}`,
            groupFeed: (groupName) => `${groupName} ${exports.SITE_NAME}`,
            groupMembers: (groupName) => `${groupName} ${exports.DASH} Учасник ${exports.SITE_NAME}`,
            groupOverview: (locationName) => `Групи ${exports.DASH} Огляд ${exports.DASH} ${locationName} ${exports.SITE_NAME}`,
            locationPicker: `Вибрати регіони${exports.SITE_NAME}`,
            login: `Зареєструватися ${exports.SITE_NAME}`,
            mailbox: `Поштова скриня ${exports.SITE_NAME}`,
            newsfeedAdditionalPage: (locationName, currentPage, totalPages) => `Сторінка ${currentPage}/${totalPages} ${exports.DASH} Оновлення з ${locationName} ${exports.SITE_NAME}`,
            newsfeedAdditionalPageIn: (place, currentPage, totalPages) => `Сторінка ${currentPage}/${totalPages} ${exports.DASH} Оновлення з ${place}`,
            newsfeedFirstPage: (locationName) => `Оновлення з ${locationName} ${exports.SITE_NAME}`,
            newsfeedFirstPageIn: (locationName) => `Оновлення з ${locationName}`,
            notFound: 'На жаль, сторінку не знайдено',
            notifications: `Сповіщення ${exports.SITE_NAME}`,
            privateProfile: `Профіль сесіда ${exports.SITE_NAME}`,
            profile: (name) => `${name} ${exports.SITE_NAME}`,
            profileFollowers: `Читачі ${exports.SITE_NAME}`,
            profilesDirectory: (locationName) => `Відкрийте ${locationName} ${exports.SITE_NAME}`,
            profilesDirectoryCategoryAuthorityProfiles: (locationName) => `Державні органи в ${locationName} ${exports.SITE_NAME}`,
            profilesDirectoryCategoryAuthorityProfilesIn: (place) => `Державні органи в ${place}`,
            profilesDirectoryCategoryPressProfiles: (locationName) => `Ващі редакції в ${locationName} ${exports.SITE_NAME}`,
            profilesDirectoryCategoryPressProfilesIn: (place) => `Ващі редакції в ${place}`,
            profilesDirectoryCategoryPrivateProfiles: (locationName) => `Ващі сусіди в ${locationName} ${exports.SITE_NAME}`,
            profilesDirectoryCategoryPrivateProfilesIn: (place) => `Ващі сусіди в ${place}`,
            profilesDirectoryIn: (place) => `Відкрийте ${place}`,
            recentFolloweesFeed: `Дописи профіля ${exports.SITE_NAME}`,
            recentGroupsFeed: `Дописи групи ${exports.SITE_NAME}`,
            registration: `Зареєструватися ${exports.SITE_NAME}`,
            resetPassword: `Скинути пароль ${exports.SITE_NAME}`,
            settings: `Налаштування ${exports.SITE_NAME}`,
            shapeSponsors: `партнери місця ${exports.SITE_NAME}`,
            topicChat: `Чат ${exports.SITE_NAME}`,
        },
    },
    neighborChat: {
        isTyping: 'пише ...',
        joinChat: 'Приєднатися до чату',
        messagesTitle: 'Чат',
        neighborsOnline: (count) => `${count} ${count === 1 ? 'Користува' : 'Коричтувачі'} в мережі`,
        neighborsTitle: 'Зараз онлайн',
        showNeighbors: 'Показати користувача',
    },
    newUserInfoCTA: {
        body: 'Обміняйтеся ідеями з сусідами. ' +
            'Отримуйте щоденні місцеві новини. ' +
            'Знайдіть події поблизу.',
        title: 'Що сталося нового у вашому районі?',
    },
    newsfeed: {
        highlights: {
            allFollowewPosts: 'Дописи користувачів, за якими ви стежите',
            allGroupPosts: 'Більше дописів з групи',
            moreFolloweePosts: 'Більше дописів із профілів, за якими ви стежите',
            moreGroupPosts: 'Більше дописів з ваших груп',
            mostInteracted: (locationShapeName) => `Про це говорить ${locationShapeName}`,
            mostViewed: (locationShapeName) => `Це цікавить ${locationShapeName}`,
            newsFromTheLast24Hours: 'Нове за останні 24 години',
            recentFolloweePostsTitle: 'Стежить: ',
            recentGroupPostsTitleFallback: 'Групи',
        },
        loadingError: 'не можливо завантажити дописи.',
        moreItemsInPostGroup: (count) => `${count}` + (count === 1 ? ' інший допис' : ' інші дописи') + ' від твого сусіда',
        noNewsAvailable: 'Тут ще немає дописів.',
    },
    notification: {
        defaultInitiatorName: 'Користувач',
        eventParticipationEnd: 'частина.',
        eventParticipationStart: 'приймає участь в події',
        followeeEvent: (teaserAvailable) => teaserAvailable
            ? 'створили нову подіюt: '
            : 'створили нову подію.',
        followeePost: (teaserAvailable) => teaserAvailable
            ? 'створили новий допис: '
            : 'створили новий допис.',
        loadingError: 'Не вдалося завантажити сповіщення.',
        newFollower: 'стежить за тобою.',
        noneYet: 'У вас ще немає сповіщень.',
        notificationBookmark: 'додав коментар на',
        notificationBookmarkableTypeComment: 'ваш коментар',
        notificationBookmarkableTypeEvent: 'ваше подію',
        notificationBookmarkableTypePost: 'ваш допис',
        notificationComment: '',
        notificationCommented: '.',
        notificationGroupPostEnd: ' створив: ',
        notificationGroupPostStart: 'новий допис у групі ',
        notificationMessage: 'написав вам нове повідомлення.',
        notificationReacted: 'відреагував.',
    },
    onboardingSettings: {
        action: 'Дії',
        address: 'Адреса',
        addressCorrect: 'Чи правильна адреса?',
        addressStopperText: 'Якщо ви переїхали, надішліть нам повідомлення ' +
            'на наступну поштову адресу. Ми відправемо вам машина для перевезення речей. 🚐',
        adjustYourArea: 'Оновіть свою юрисдикцію',
        alreadyExistPhoneNumber: 'Номер телефону не можна використовувати.',
        backToPost: 'Назад до допису',
        birthday: 'Дата народження',
        birthdayFormat: 'ДД.ММ.РРРР',
        blockedNeighbors: 'Заблокований сусід',
        business: 'Підприємці & Постачальники послуг',
        businessDescription: 'Роздрібна торгівля, ремесло ...',
        cannotUseEmailAddress: 'Не можливо використати адресу електронної пошти.',
        category: 'Категорії',
        changeAddress: 'Змінити адресу',
        changePasswordBodyText: 'Просто натисніть кнопку нижче, ' +
            'потім ми надішлемо вам електронного листа для відновлення пароляs.',
        changePasswordTitle: 'Змінити пароль',
        changeYourPhoto: 'Змінити зображення',
        checkYourEmailForUpdatingEmail: 'Будь ласка, підтвердьте свою електронну адресу ' +
            'використавши посилання в електронному листі.',
        chooseCategory: 'Виберіть, будь ласка, категорію',
        chooseProfile: 'Як би ви хотіли приєднатися??',
        collected: 'Колективно',
        comments: 'Коментарі',
        completeProfileBody: 'Щоб мати можливість користуватися нашим додатком, спочатку потрібно заповнити свій профіль.\n' +
            'Для цього перейдіть у свої налаштування на нашому сайті.',
        completeProfileButton: 'Перейдіть до lokalportal.de',
        completeProfileTitle: 'Ви хочете прийняти участь в дискусії?',
        connections: 'Звязки',
        contactNumber: 'Номер телефону',
        contactPerson: 'Контактна особа',
        contactPersonLopo: 'Sabrina Krause',
        contactUsEmail: 'hilfe@lokalportal.de',
        contactUsSubheadline: 'Ваша контактна особа',
        correctVerificationCode: 'Все добре! Введений вами код підтвердження правильний.',
        createProfileStepsHeadline: 'Приєднуйтесь',
        dailyUpdateEmailHeadline: 'Новини з',
        dailyUpdateEmailInfo: (location) => 'Хто з нових сусідів у вашому районі ' +
            'та про що вони там говорять. Саме про це ви дізнаєтеся з нашої щоденної електронної розсилки.' +
            '\n\nТут ви можете вказати, чи хочемо ми регулярно надсилати вам електронні листи про останні новини' +
            `${location} informieren sollen.`,
        dateFormat: 'ДД.ММ.РРРР',
        deleteAccount: 'Видалити обліковий запис користувача',
        deleteAccountInfo1: 'Якщо ви натиснете «Видалити обліковий запис користувача», усі ваші профілі з усіма особистими даними та вмістом (публікації, коментарі, події) будуть безповоротно видалені.',
        deleteAccountInfo2: 'Будь ласка, підтвердьте видалення свого облікового запису паролем. ' +
            'Для повного видалення всіх ваших даних може знадобитися до 30 днів.',
        deleteAccountInfo3: 'У вас є кілька профілів, але ви хочете видалити лише певний?' +
            'Тоді напишіть нам повідомлення:',
        deleteAccountPasswordError: 'Будь ласка, введіть свій поточний пароль.',
        description: 'вступний текст',
        doItLater: 'Я зроблю це пізніше',
        dontForgetYourHouseNumber: 'Не забувайте номер свого будинку! ',
        dontMissAnyNews: 'Не пропустіть більше жодної новини!',
        dontWorryItsNotVisible: 'Не хвилюйся! Вашу адресу не бачать інші користувачі.',
        emailAddressChange: 'змініть адресу електронної пошти',
        emailChangeError: 'Сталася помилка при зміні електронної адреси.',
        emailChangeSuccess: 'Вашу адресу електронної пошти було успішно змінено.',
        emailRegistrationError: 'Під час підтвердження електронної адреси сталася помилка.',
        emailRegistrationSuccess: 'Вашу електронну адресу було успішно підтверджено.',
        emptyFolloweeListButton: 'Ось пошук',
        emptyFolloweeListInfo: 'Ви ще не стежите за жодним профілем. Завітайте до пошуку, ' +
            ' там ви знайдете багато цікавих профілів, за якими ви можете стежити. Таким чином ви завжди будете в курсі' +
            'їхніх новин.',
        enterCode: 'Введіть свій код підтвердження',
        extendedOptions: 'Розширені налаштування',
        facebookRegistrationError: 'Під час реєстрації сталася помилка.',
        female: 'Жіноча',
        firstLookAround: 'Спочатку перегляньте',
        firstLookAroundNow: ' Перегляньте зараз',
        firstName: 'Ім я',
        firstNameEmpty: 'Будь ласка, введіть своє ім я.',
        followedProfiles: 'Підписані користувачі',
        further: 'Інші',
        furtherSettings: 'Інші налаштування',
        giveYourContactNumber: 'Вкажіть свій контактний номер (необов’язково)',
        giveYourContactPerson: 'Вкажіть контактну особу',
        giveYourImpressum: 'Вкажіть свій відбиток (необов язково)',
        giveYourInternetSite: 'Який ваш веб-сайт (необов’язково)',
        hiddenNeighbors: 'Приховані сусіди',
        iHaveAlreadyCode: 'У мене вже є код',
        immediately: 'Відразу',
        infocardAddressTitle: 'Новини з вашого найближчої околиці',
        infocardDateOfBirthBody: 'Надання дати народження є добровільним. ' +
            'Інші сусіди не можуть побачити ваш день народження.',
        infocardDateOfBirthTitle: 'Тільки якщо ви хочете, щоб ...',
        infocardNameBody: 'Справжні сусіди зі реальними іменами ведуть до набагато приємнішої взаємодії ' +
            'та довірливого обміну на місцевому порталі. ' +
            'Ваші сусіди будуть щасливі дізнатися з ким вони розмовляють.',
        infocardNameTitle: 'Хто цей дурень?',
        internetSite: 'Інтернет сторінка',
        internetSiteError: 'Веб-сайт не дійсний',
        introduceYouToYourNeighbor: 'Познайомтеся зі своїми сусідами (за бажанням)',
        invalidName: 'Дві літери повинні йти одна за одною.',
        invalidPhoneNumber: 'Номер телефону недійсний',
        invalidVerificationCode: 'Код підтвердження недійсний',
        lastAttempt: 'У вас є ще одна спроба!',
        lastName: 'Призвіще',
        lastNameEmpty: 'Будь ласка, введіть своє прізвище.',
        letsGo: 'Починаємо зараз!',
        letterNotReceived: 'Ви правильно ввели свою адресу, але ще не отримали від нас жодного листа? Тоді надішліть нам повідомлення: ',
        male: 'Чоловіча',
        mutedProfiles: 'Прихований профіль',
        myInterests: 'Мої вподобання',
        myInterestsInfo: 'Висловіть свої інтереси та знайдіть однодумців' +
            'щоб поділитися своїми улюбленими темами. Вашого інтересу ще немає? ' +
            'Надішліть нам свою пропозицію якомога швидше ',
        name: 'Імя',
        neighbor: 'Сусід',
        neighborDescription: 'Для приватних осіб',
        newEmailAddress: 'Нова адреса електронної пошти',
        newProfile: 'Створити новий профіль',
        newProfileInfo: 'Чи бажаєте ви створити інший профіль? ' +
            'Виберіть, чи хочете ви створити приватний або публічний профіль.',
        newsletter: 'Розсилка новин',
        newsletterInfo: 'У нашій розсилці ми інформуємо вас про цікаві публікації' +
            'з вашого регіону, про акції та нові функції.\n\nТут ви можете ' +
            'налаштувати, чи бажаєте ви постійно отримувати такі листи.',
        noAlwaysEditable: 'Ні (можна змінити в будь-який час)',
        notAvailableMessage: 'Не вдалося завантажити деякі налаштування.',
        notSavedCorrectly: 'Не вдалося зберегти',
        notifications: 'Сповіщення',
        organisation: 'Організації',
        organisationDescription: 'Обєднання, Ініціативи...',
        other: 'Інше',
        phone: 'Номер телефона',
        post: 'Лист',
        postCardSend: 'У вас є непрочитані повідомлення!',
        postCardSendInfo1: 'Ми надішлемо вам листа',
        postCardSendInfo2: '. Він має прийти до вас через сім днів.',
        postCardWaring: 'Щоб наш лист надійшов до вас, введіть повну адресу. ' +
            'Переконайтеся, що ви не забули номер свого будинку.',
        profile: 'Профіль',
        profileDescriptionPlaceholder: 'Представтеся своїм сусідам.',
        profileName: 'Імя профілю',
        profilePicture: 'Профільне фото',
        profileSetting: 'Налаштування профілю',
        profileTypeAssociation: 'Організації',
        profileTypeBlogger: 'Публічна особа',
        profileTypeBusiness: 'Бізнес',
        publicPerson: 'Публічна особа',
        publicPersonDescription: 'Блогер, Автор, митець...',
        publicProfile: 'Публічний профіль',
        publicProfileChoice: 'Для обєднань, ініціатив, компаній тощо.',
        publicProfileContent: 'Ми допомагаємо створити публічний профіль. ' +
            'Якщо ви є контактною особою державного органу, зв’яжіться з нами безпосередньо.',
        publicProfileDescription: 'Влада, поліція, пожежна команда...',
        publicProfileHeader: 'Державний орган',
        publisher: 'Журналісти',
        publisherDescription: 'Видавництво, редакції, журнали',
        reactions: 'Реакції',
        regularyEmails: 'Постійні електронні листи',
        requestVerification: 'Запит коду підтвердження',
        responsibilityArea: 'Зона відповідальності',
        responsibilityAreaContent: 'Ми раді допомогти з питаннями або змінити запити в будь-який час',
        returnToLogin: 'Повернутись до входу',
        securityIsImportant: 'На всякий випадок',
        selectCategories: 'Виберіть до трьох рубрик',
        sendMeCodeWithPost: 'Надішліть мені код листом',
        sendMeCodeWithSMS: 'Надішліть мені код СМС повідомленням',
        sentMail: 'Ми знову надіслали вам електронний лист із підтвердженням.',
        sms: 'СМС повідомлення',
        smsCodePending: 'Ми надіслали вам СМС із кодом підтвердження.',
        smsInfoMail: 'hallo@lokalportal.de',
        smsInfoText1: 'Якщо ви ввели неправильний номер, надішліть нам повідомлення ',
        smsInfoText2: ', щоб ви могли завершити реєстрацію.',
        smsVerificationCode1: 'Ми надіслали вам СМС із кодом підтвердження',
        smsVerificationCode2: ' .',
        smsVerificationCode3: 'Ви не отримали СМС повідомлення? Будь ласка ',
        smsVerificationCode4: 'спробуйте знову.',
        smsVerificationNoAttempts1: 'Упс... це була ваша остання спроба. Але не переймайтесь! Напишіть нам' +
            ' повідомлення',
        smsVerificationNoAttempts2: ' щоб ми вам допомогли.',
        smsVerificationNoAttempts3: 'Крім того, ми будемо раді надіслати вам код підтвердження поштою.',
        splashNewsletterMessage: 'Хочете, щоб ми або наші партнери регулярно інформували вас' +
            'про нові публікації електронною поштою?',
        splashSuccessAssociation: 'Ознайомтеся зі своєю організацією та тим, що робить її особливою.',
        splashSuccessBlogger: 'Привітайтеся зі своїми сусідами та познайомтеся зі своїм оточенням.',
        splashSuccessBusiness: 'Презентуйте свій бізнес і продемонструйте ваші акцій та пропозицій.',
        splashSuccessPrivate: 'Представтеся своїм сусідам і поділіться з ними останніми новинами.',
        toBriefVerification: 'До перевірки листа',
        uploadYourPhoto: 'Завантажте зображення (необов’язково)',
        verification: 'Верифікація',
        verificationCode: 'Код підтвердження',
        verified: 'Верифіковано',
        verifyYourVerificationCode: 'Щоб верифікувати ваш профіль' +
            'будь ласка надайте код підтвердження.',
        viewCountNotify: 'Враження',
        weNeedYourAddress: 'Для призначення сусідства, ' +
            'нам потрібна ваша адреса ',
        welcomeToLopo: 'Ласкаво просимо до місцевого порталу!',
        welcomeToNeighborhood: 'Ласкаво просимо до сусідства',
        whatIsYourName: 'Як вас звати',
        whatIsYourProfileName: 'Як ви хочете назвати ваш профіль?',
        writeAPost: 'Напишіть свій перший допис',
        youCanDeleteAccount: 'Тут ви можете видалити свій обліковий запис користувача',
        youGotEmail: 'У вас є повідомлення!',
        yourAddress: 'Ваша адреса',
        yourAddressIsNotPublic: 'Ваша адреса не відображається для інших',
        yourAddressIsPublic: 'Адреса вашого публічного профілю',
    },
    pageTitles: {
        addProfile: 'Додати профіль',
        eventParticipants: 'Список учасників',
        eventParticipatingFeed: 'Події',
        eventfeed: 'Події для ',
        eventfeedSimple: 'Події',
        events: 'Події: ',
        followers: 'Читачі',
        for_: ' для ',
        groupFeed: (groupName) => `Gruppe: ${groupName}`,
        groupOverview: 'Групи',
        inbox: 'Поштова скринька',
        locationPicker: 'Вибрати регіон',
        newsfeed: 'Актуальне для ',
        newsfeedSimple: 'Актуальне',
        notifications: 'Сповіщення',
        profile: 'Профіль',
        profileSearch: 'Пошук',
        profileSearchSimple: 'Пошук',
        recentFolloweesFeed: 'Дописи профіля',
        recentGroupsFeed: 'Дописи групи',
        resetPassword: 'Скинути пароль',
        settings: 'Налаштування',
        shapeSponsors: 'Видалити партнера',
        signIn: 'Вхід',
    },
    postCreate: {
        addEndDate: 'Додати дату закінчення',
        addEventCategory: 'Будь ласка виберіть категорію',
        addPictureActionSheetHeader: 'Додати фото',
        addressSubmenuTitle_APP: 'Адреса або місце',
        addressSubmenuTitle_WEB: 'Адреса',
        cameraPermissionErrorBody: 'Спочатку дозвольте нам доступ до вашої камери. ' +
            'Для цього перейдіть до своїх налаштувань.',
        cameraPermissionErrorTitle: 'Місцевий портал не має доступу до вашої камери',
        cameraRoll: 'Галерея',
        campaignAddOffer: 'Запропонуйте свої поточні пропозиції',
        campaignBillingButton: 'Розмістіть допис за окрему плату',
        campaignBillingHeadline: 'Огляд',
        campaignBillingTermsOfUse: 'Я це підтверджую ',
        campaignBillingText1: 'Ми надішлемо вам рахунок на адресу,' +
            'яку ви вказали у своєму профілі під час реєстрації.\nНатиснувши на кнопку, ваш допис буде опубліковано на місцевому порталі',
        campaignBillingText2: ' та рекламуватися у Facebook, Instagram та Google протягом 24 годин.',
        campaignBillingTitle: 'Оплата',
        campaignDeletePostTooltip: 'Оголошення не можна видалити.',
        campaignError: 'На жаль, цю операцію не вдалося провести.',
        campaignErrorDeletePost: 'Видалити допис',
        campaignErrorHeadline: 'Помилка',
        campaignErrorKeepPost: 'Залишити допис',
        campaignErrorText1: 'Ваша публікація була опублікована, але, на жаль, її не вдалося рекламувати. Поки ' +
            'ваш допис не рекламується, ми, звичайно, не будемо стягувати з вас витрати на рекламу. Просто спробуйте ще раз! ' +
            'Ви також можете зберегти свою публікацію, не рекламуючи її та не видаляючи.',
        campaignErrorText2: 'Якщо у вас виникли запитання, надішліть нам повідомлення ',
        campaignErrorTryAgain: 'рекламувати допис',
        campaignIntroDuration: '24 години',
        campaignIntroFooter: 'Додаткову інформацію про оголошення можна знайти в ',
        campaignIntroHeadline: 'Звертайтеся до людей, які важливі для вашого бізнесу',
        campaignIntroSocialMeda: 'канали соціальних мереж',
        campaignIntroTermsOfUse: 'Умови використання',
        campaignIntroText1: 'Швидко й легко рекламуйте свої поточні пропозиції та послуги за допомогою реклами' +
            'та залучайте людей із вашого регіону безпосередньо до свого бізнесу.',
        campaignIntroText2_1: 'Ваш внесок буде опубліковано не тільки на локальному порталі, а й для ',
        campaignIntroText2_2: ' на відомому ',
        campaignIntroText2_3: ' рекламується – і тільки ',
        campaignIntroText3: 'Таким чином ви охоплюєте своїх клієнтів, де б вони не були.',
        campaignPreviewTitle: 'попередній перегляд',
        campaignSubmitting: 'Рекламуйте допис локально',
        campaignSuccessButtonNewsfeed: 'Назад до стрічки новин',
        campaignSuccessButtonPost: 'рекламувати допис',
        campaignSuccessHeadline1: 'Чудово, це спрацювало!',
        campaignSuccessHeadline2: 'Ви хочете ще більшого діапазону?',
        campaignSuccessText1: 'Ваша публікація буде опублікована та рекламована у Facebook, Instagram та Google ' +
            'протягом 24 годин.',
        campaignSuccessText2: 'Дякуюмо за замовлення!',
        campaignSuccessText3: 'Поділіться своїм дописом!',
        campaignSuccessTitle: 'Підтвердження',
        campaignWarningText1: 'Після того як ви розмістили своє оголошення за плату, ви можете редагувати його лише на',
        campaignWarningText2: ' ви можете редагувати його лише на. У Facebook, Instagram та Google ваше оголошення' +
            'більше не можна редагувати.',
        campaignWarningText3: 'Оголошення не можна видалити пізніше',
        campaignWarningTitle: 'Увага!',
        campaignWriteMedia: 'Якою була б ваша реклама без цікавого фото?',
        cancelMessage: 'Ваша допис ще не закінчений. Ви дійсно хочете залишити сторінку, ' +
            'не закінчивши допис?',
        cancelTitle: 'Ви дійсно хочете залишити сторінку?',
        closeWindow: 'залишити сторінку',
        commentsTitle: 'Kommentare erlauben?',
        continueWritingPost: 'продовжити створення допису',
        createEventSubtitle: '... і це вже в календарі',
        createEventTitle: 'Свторіть подію',
        createPostSubtitle: 'Розкажіть всім у вашому оточенні',
        createPostTitle: 'Що нового?',
        descriptionIsMissing: 'Будь ласка, введіть опис.',
        descriptionOptionalPlaceholder: 'Опис (необовязково)',
        descriptionPlaceholder: 'Поділіться новинами з вашими сусідами',
        endDate: 'Кінцевй термін',
        endDateRequired: 'Введіть будь ласка кінцевий термін.',
        endDateShouldNotBeforeStartDate: 'Дата закінчення не може бути раніше дати початкуn.',
        endTime: 'Час закінчення',
        endTimeNotInThePast: 'Не кажіть, що ви можете повернутися в минуле?! 😱',
        endTimeRequired: 'Введіть будь ласка час закінчення',
        eventDescriptionPlaceholder: 'Опис',
        flagPost: 'Поскаржитись на допис',
        guideText: 'Тримайте своїх сусідів в курсі! Поділіться з ними новинами та спостереженнями та публікуйте фотографії ' +
            'які вам подобаються.',
        guideTextCampaign: 'Створіть оголошення зараз і досягайте охоплюйте більше!',
        guideTextNew: 'Зараз нове:',
        guideTitle: 'Що ви хочете зробити',
        headerCategory: 'Категорія',
        headerDate: 'Дата',
        headerPosition: 'місце',
        headerPreview: 'Попередній перегляд',
        imageCropperButtonBigger: 'більший',
        imageCropperButtonRotate: 'обертати',
        imageCropperButtonSmaller: 'менший',
        imageCropperButtonTitleImage: 'заголовок зображення',
        imageCropperTitle: 'редагувати фото',
        imageGalleryPermissionErrorBody: 'Спочатку надайте нам доступ до вашої галереї. ' +
            'Для цього перейдіть до своїх налаштувань.',
        imageGalleryPermissionErrorTitle: 'Місцевий портал не має доступу до ваших фотографій і відео',
        imageSelectionErrorBody: 'При завантаженні фото сталас помилка.',
        lessThanThreeDays: 'Подія не може тривати більше 3 днів.',
        mediaDeleteButton: 'Видалити фото',
        mediaMaxImages: (maxImages) => `max. ${maxImages} Bilder`,
        mediaMaxImagesError: (maxImages) => `На жаль, ви не можете завантажити більше ніж ${maxImages} зображень.`,
        mediaMaxImagesGenericError: 'На жаль, ви не можете завантажити більше фотографій.',
        mediaPermissionErrorBody: 'Спочатку надайте нам доступ до вашої галереї та камери. ' +
            'Для цього перейдіть до своїх налаштувань.',
        mediaPermissionErrorTitle: 'Місцевий портал не має доступу до ваших файлів',
        mediaSelectSubtext: 'Додати',
        mediaSelectText: 'Додайте картинки до свого посту.',
        mediaTitle: 'Фото',
        moreMediaPlural: 'інщі фото',
        moreMediaSingular: 'інша картинка',
        postSubmitting: 'Ваш допис опубліковано.',
        previewLoadingError: 'Не вдалося завантажити попередній перегляд.',
        previewMessage: (location) => `Ваша публікація відображається в ${location}.`,
        previewText: 'Ви цим задоволені??',
        removeEndDate: 'Видалити кінцевий термін',
        removePreviewLink: 'Видалити попередній перегляд посилання',
        selectSubtitleCampaign: 'Пост із великим охопленням',
        selectSubtitleEvent: 'Публічна подія або зустріч',
        selectSubtitlePublicPost: 'Загальнодоступна публікація',
        selectSubtitleSnapshot: 'Формат фотографій для всіх зображень',
        selectSubtitleSurvey: 'Create a survey',
        selectTitlePublicPost: 'Допис',
        shareYourInformation: 'Поширюйте свою актуальну інформацію',
        snapshotLocationBody: 'Покажіть сусідам, де було зроблено ваш знімок, ' +
            'щоб вони також могли відвідати це місце.',
        snapshotLocationTitle: 'Де ви зробили цей знімок?',
        startDate: 'Anfangsdatum',
        startDateRequired: 'Bitte gib ein Anfangsdatum ein.',
        startDateShouldNotBeThePast: 'Die Veranstaltung muss in der Zukunft liegen.',
        startTime: 'Час початку',
        startTimeRequired: 'Будь ласка, введіть час початку.',
        surveyAnswersTitle: 'Answers',
        surveyCreateButton: "Create survey",
        surveyDatepickerPlaceholder: "Set date",
        surveyDatepickerTitle: "Set end date",
        surveyOption: (index) => `Option ${index}`,
        surveyOptionAdd: "Add answer",
        surveyQuestionPlaceholder: "Title",
        surveyQuestionTitle: "Question",
        surveySubmitting: 'Your survey will be published.',
        takePicture: 'Зробити знімок',
        titleIsMissing: 'Будь ласка, введіть назву.',
        titlePlaceholder: 'Заголовок',
        whereToPin: 'Де закріпити місце на карті?',
        writeTitleCampaign: 'Оголошення',
    },
    postDetail: {
        relatedContentSubtitle: 'Вас це може зацікавати',
        relatedContentTitle: 'Інщі дописи',
        source: 'Ресурм',
        tickets: 'Квитки',
    },
    postTypes: {
        event: 'Подія',
        groupPost: 'Допис в групі',
        publicPost: 'Допис',
        snapshot: 'Знімок',
        survey: 'Survey',
    },
    premiumContentInfo: {
        body: 'Ви хочете прочитати всі повідомлення в місцевому порталі? Просто зареєструйтеся безкоштовно.',
        bodyTitle: 'Приєднуйтесь до нас та станьте частиною місцевого порталу!',
        bullet1: 'Отримуйте ексклюзивні місцеві новини',
        bullet2: 'Обміняйтеся ідеями з сусідами',
        bullet3: 'Знайдіть події поблизу',
        title: 'Читайте більше безкоштовно',
    },
    profile: {
        aboutMe: 'Про мене:',
        authorityProfile: 'Перевірений профіль',
        blog: 'Сторінка',
        blogProfile: 'Сторінка з',
        blurredLoggedOutBody: 'Найкраще у знайомстві один з одним, те що завжди дві сторони зацікавлені в цьому. \n' +
            'Ви можете переглядати профілі сусідів, ' +
            'лише якщо ви зареєструвалися на мсцевому порталі.',
        blurredLoggedOutBodyTile: (profileName) => `Du möchtest ${profileName} besser kennenlernen?`,
        editProfile: 'Редагувати профіль',
        extensionAuthority: 'Відкритий профіль',
        extensionBlog: 'Сторнки',
        extensionPress_APP: 'Ваша місцева редакція',
        extensionPress_WEB: 'Редакція',
        extensionPrivate: 'Сусід',
        extensionUnknown: '',
        giveYourInterests: 'Висловіть свої інтереси та знайдіть однодумців ' +
            'для спілкування на певні теми.',
        myInterests: 'Мої вподобання:',
        neighborFromFemale: 'Сусідка з',
        neighborFromMale: 'Сусід з',
        neighborMale: 'сусід',
        press: 'Редакція',
        pressProfile: 'Редакція з',
    },
    profileList: {
        orderBy: 'Сортувати за:',
        orderByAccessionDate_APP: 'Дата реєстрації',
        orderByAccessionDate_WEB: 'Дата реєстрації (спочатку нові)',
        orderByName: 'Імя',
        orderDirectionAscendingDate: 'спочатку старі',
        orderDirectionAscendingName: 'за зростанням',
        orderDirectionDescendingDate: 'спочатку нові',
        orderDirectionDescendingName: 'по спаданню',
    },
    profileSearch: {
        relatedContentSubtitle: 'Це можу вас зацікавити.',
        searchAndDiscover: 'Шукайте та відкривайте',
    },
    pushNotification: {
        permissionAlertBody: 'Якщо ви налаштуєте сповіщення, ви більше не пропустите новини ' +
            'зі свого оточення. Ви можете вимкнути їх у будь-який час у налаштуваннях.',
        permissionAlertCancelAction: 'Не дозволити',
        permissionAlertPositiveAction: 'Дозволити',
        permissionAlertTitle: 'Пуш-нотифікації',
    },
    rateTheApp: {
        addRating: 'Дати оцінку',
        doYouLikeLopo: 'Вам подобається місцевий портал?',
        no: 'Ні',
        notYet: 'Не зараз',
        rateTheAppBody: 'Оцініть додаток місцевого порталу в магазині Google Play.',
        rateTheAppTitle: 'Юху! Ми з нетерпінням чекаємо вашої оцінки.',
        yes: 'Так',
    },
    reactions: {
        condolences: 'Мої співчуття',
        countInfo: (profileName, count) => {
            const maxCharacters = 14;
            let truncatedName = profileName;
            if (profileName.length > maxCharacters) {
                truncatedName = profileName.substring(0, maxCharacters) + '...';
            }
            switch (count) {
                case 1:
                    return profileName;
                case 2:
                    return `${truncatedName} та ще 1 сусід`;
                default:
                    return `${truncatedName} und ${count - 1} іні сусіди`;
            }
        },
        emptyReactions: 'На цей пост поки немає реакцій.',
        haha: 'Смішно',
        interesting: 'Цікаво',
        like: 'Мені подобається',
        ohNo: 'Сумно',
        reactions: 'реакції',
        title: 'Що ви думаєте про цей допис?',
        wow: 'Вау',
    },
    relatedContent: {
        headline: 'Інщі дописи',
        subHeadline: 'Це може вас зацікавити',
    },
    reloadPage: {
        message: 'Вийшла нова версія місцевого порталу. Оновіть сторінку, щоб ви могли продовжувати, ' +
            'користуватися локальним порталом.',
        reload: 'Перезавантажити',
    },
    screenReaderText: {
        addMorePictures: 'Додати інщі фото',
        administrator: 'Адміністратор',
        close: 'Закрити',
        closeChat: 'Закрити чат',
        closeMap: 'Закрити карту',
        message: 'Сповіщення',
        moreOptions: 'Більше опцій',
        new: ' новий ',
        nextDay: 'Наступний день',
        nextMonth: 'Наступний місяць',
        nextYear: 'Наступний рік',
        notification: 'Сповіщення',
        openCalendar: 'Вікрити календар ',
        openChat: 'Вікрити чат',
        openMap: 'Вікрити карту',
        openMenu: 'Вікрити меню',
        photoGallery: 'Фото галерея',
        previousDay: 'Попередній день',
        previousMonth: 'Попередній місяць',
        previousYear: 'Попередній рік',
        stepCompleted: 'Крок завершено',
        titlePicture: 'Фото на обкладинці',
        viewMessage: 'Подивитись новину',
    },
    shapeSponsors: {
        bronzePartner: 'Партнер поряд',
        formBody: 'Хочете, щоб ваш профіль був у центрі уваги? Як партнер поряд, ваше зображення профілю з’явиться ' +
            'у верхній частині нашої домашньої сторінки та буде виділено. Таким чином ви отримуєте ' +
            'ще більше переглядів.\n\n' +
            'Бажаєте стати партнером поряд чи у вас є запитання? Напишіть нам коротке повідомлення, ' +
            'і наша редакція зв’яжеться з вами якомога швидше. Якщо хочете, напишіть, будь ласка, свій номер телефону' +
            'так ми звяжесося ще швидше. ☎',
        formSuccessBody: 'Ми зв’яжемося з вами якнайшвидше!',
        formSuccessTitle: 'Ми незабаром отримаємо ваше повідомлення',
        formTitle: 'Станьте партнером поряд!',
        inputErrorText: 'Будь ласка, введіть своє повідомлення.',
        inputPlaceholder: 'Ваша новина',
        silverPartner: 'Преміум партнер',
        title: 'Партнера поряд',
    },
    share: {
        email: 'Електронна пошта',
        facebook: 'Facebook',
        greeting: 'Чи відомий вам місцевий портал - платформа для місцевого життя?\n' +
            'Я вже там спілкуюся з сусідами. ' +
            'Приєднуйся до нас і реєструйся безкоштовно \n',
        link: 'Посилання',
        linkWasCopiedToClipboard: 'Посилання скопійовано в буфер обміну.',
        share: 'Поділитися',
        subject: 'Я хочу запросити вас до місцевого порталу!',
        twitter: 'Twitter',
        whatsapp: 'WhatsApp',
    },
    shared: {
        aboutUs: 'Про нас',
        addInterests: 'Додати інтереси',
        and: 'і',
        back: 'Назад',
        blog: 'Блог',
        cancel: 'Відмінити',
        close: 'Закрити',
        continue: 'Далі',
        delete: 'Видалити',
        done: 'Готово',
        edit: 'Редагувати',
        email: 'Адреса електронної пошти',
        emptyFeedText: 'На жаль, тут ще немає дописів.',
        emptyListText: 'На жаль, зараз тут немає нічого цікавого.',
        errorEmail: 'Перевірте свою електронну адресу.',
        errorUnknown: 'Упс... щось пішло не так.',
        faq: 'FAQ',
        feedback: 'Відгук',
        forMe: 'Для мене',
        formAssistiveText: 'Розділіть адреси комами.',
        formErrorInvalid: 'Туди закралася помилка',
        genericErrorBody: 'Щось пішло не так при останніх діях',
        genericErrorLong: 'Упс... щось пішло не так.\nБудь ласка спробуйте пізніше.',
        genericErrorTitle: 'Упс...',
        helpEmail: 'support@rukadopomohy.org',
        hereIsMore: 'Тут є більше!',
        imageAddError: 'На жаль, під час додавання зображення сталася помилка!',
        imprint: 'Відбиток',
        inputTooShort: (minCharacters) => `Bitte gib mindestens ${minCharacters === 1 ? 'ein' : minCharacters} Zeichen ein.`,
        jobs: 'Вакансії',
        learnMore: 'Більше про місцевий портал',
        login: 'Увійти',
        logout: 'Вийти',
        lokalportal: 'Місцевий портал',
        lokalportalSite: 'lokalportal.de',
        maxCharacters: (maxCharacters) => `max. ${maxCharacters} Zeichen`,
        neighborhood: 'Сусідство',
        never: 'Ні',
        newVersion: 'Доступна нова версія',
        noLocalResultFound: 'На жаль, у цьому регіоні не вдалося знайти жодних результатів.',
        noResultFound: 'Вибачте, результатів знайти не вдалося.',
        ok: 'Добре',
        or: 'або',
        pageNotFound: 'оу ... нажаль не вдалося знайти допси.',
        paginationButtonTitle: (page) => `Seite ${page}`,
        password: 'Пароль',
        period: '.',
        privacy: 'Конфіденційність',
        register: 'Зареєструватися',
        registerNow: 'Зареєструватися',
        required: '*Обов язкове поле',
        retry: 'Спробувати ще раз',
        save: 'Зберегти',
        sayHello: 'Напишіть привіт!',
        send: 'Відправити',
        settings: 'Налаштування',
        showAll: 'Показати все',
        submit: 'Відмінити відправку',
        terms: 'Умови використання',
        understood: 'Зрозуміло',
        verify: 'Верифікувати',
        version: 'Версія',
        welcomeBack: 'Ласкаво просимо знову',
        writeMessage: 'написати повідомлення',
        yes: 'Так',
    },
    spread: {
        formFieldEmailsPlaceholder: 'Адреса електронної пошти(n)',
        formFieldMessagePlaceholder: 'Текст вашого запрошення',
        formFieldSenderPlaceholder: 'Ваше імя',
        formIntro: 'Розкажіть своїм сусідам та друзям про місцевий портал. Чим більше сусідів, ' +
            'тим краще спілкування.',
        formOptional: 'За бажанням',
        formSubmitButton: 'Надіслати запрошення',
        formTitle: 'Ваші сусіди вже з нами?',
        shareIntro: 'Поділіться місцевим порталом зі своїми друзями:',
        thanksMessage: 'Ваше запрошення надіслано. Ми раді, що ви допомагаєте, ' +
            'зробити наша портал ще жвавшим. 🤗',
        thanksTitle: 'Чудово, це спрацювало!',
    },
    welcomeScreen: {
        backtoPost: 'Назад до допису',
        completeProfileSubtitle: 'Продемонтсруйте ващі кращі сторони',
        completeProfileTitle: 'Заповнити профіль',
        followProfilesSubtitle: 'Не пропустіть жодних новин',
        followProfilesTitle: 'Стежити за користувачами',
        headerTitle: 'Ласкаво просимо',
        joinGroupsSubtitle: 'Знайти групи поряд',
        joinGroupsTitle: 'Долучитися до групи',
        title: 'Відкрийте для себе місцевий портал та сусідство.',
    },
    wizard: {
        request: 'Запросити',
        send: 'Відправити',
        start: 'Почати',
    },
};
